<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';

const props = defineProps<{
  modelValue: string;
  placeholder?: string;
  error?: string | null;
  minRows?: number;
}>();
defineEmits<{ 'update:modelValue': [value: string] }>();

const ta = ref<HTMLTextAreaElement | null>(null);

function autosize() {
  const el = ta.value;
  if (!el) return;
  el.style.height = 'auto';
  el.style.height = el.scrollHeight + 'px';
}

onMounted(autosize);
watch(() => props.modelValue, () => autosize());
</script>

<template>
  <div :class="['ta', { 'ta--err': !!error }]">
    <textarea
      ref="ta"
      :value="modelValue"
      :placeholder="placeholder"
      :rows="minRows ?? 3"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    />
    <p v-if="error" class="ta__err">{{ error }}</p>
  </div>
</template>

<style scoped>
.ta textarea {
  width: 100%;
  background: var(--bg-input);
  color: var(--text-primary);
  border: 1px solid var(--hairline);
  border-radius: var(--r-md);
  padding: 14px 16px;
  font-size: var(--fs-base);
  outline: none;
  resize: none;
  line-height: 1.45;
  transition: border-color 0.15s;
}
.ta textarea:focus { border-color: var(--accent); }
.ta--err textarea { border-color: var(--error); }
.ta__err { color: var(--error); font-size: var(--fs-sm); margin-top: 4px; }
</style>
